import TableHeaders from "../component-assets/TableHeaders.jsx";
import TableBodySimple from "../component-assets/TableBodySimple.jsx";
import {isBannerPresent} from "../../libs.jsx";
import { getSession } from "../../services/session";

const CheckInTrans = (props) => {
    let dData, tableBody, headerData;

    headerData = [
        {label: "Checked In", key: "local_check_in_time", align: "center", type: "datetime"},
        {label: "Resident", key: "resident_name"},
        {label: "Device", key: "device_name"},
        {label: "Area", key: "area_name"}
    ]

    if (getSession() != null) {
        dData = getSession();
    }

    const tableHeaders = <TableHeaders checkbox={false} headerData={headerData} sortOrder={props?.sorter?.sortOrder}
                                       sortColumn={props?.sorter?.sortColumn} sorter={props?.sorter} setSorter={props?.setSorter}/>
    if (props?.tableRows !== undefined){
        tableBody = (<TableBodySimple tableData={props.tableRows} checkbox={false} tableHeaders={headerData} />)
    }else{
        tableBody = ""
    }

    return (
        <>
            <div>
                <h6 className={"my-1 fs-3 px-4"}>
                    {dData.campus} {props.repType} Report:
                    <span className={"fs-3 d-inline ms-2"} style={{color: "var(--color-primary)"}}>{props.start}</span>
                    -
                    <span className={"fs-3 d-inline"} style={{color: "var(--color-primary)"}}>{props.end}</span>
                </h6>
                <div className={"pt-1 pb-4 px-4 my-2"}>
                    <table className={"table table-sm table-white table-hover"}>
                        <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                            {tableHeaders}
                        </thead>
                        <tbody>
                            {tableBody}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default CheckInTrans;